import { reverse } from 'named-urls';
import { routing } from '@utils/routing';
export const createReportLink = ({ label, location }) => (reportId) => ({
    to: {
        pathname: reverse(routing.analyticsV2.reports.report.self, {
            reportId,
        }),
        search: location.search,
    },
    state: {
        from: { label, location },
    },
});
